import * as types from './types';
import actions from './actions';
import {
  extend,
  each,
  set
} from 'lodash';

const state = {
  //结算 学生列表
  settlementToolStudentList: {
    state: '',
    list: [],
    total: 0,
  },

  //结算 班级列表
  settlementToolClassList: {
    state: '',
    list: [],
    total: 0,
  },

};

const getters = {
  //结算学生列表
  getSettlementToolStudentList: (state) =>state.settlementToolStudentList,
  //结算班级列表
  getSettlementToolClassList: (state) =>state.settlementToolClassList,
};

const mutations = {
  //结算学生列表
  [types.ACTION_GET_SETTLEMENT_TOOL_STUDENT_LIST]({settlementToolStudentList}, result){
    extend(settlementToolStudentList, result)
  },


};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/tooBookStudentList/index.js